import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import type { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import {
  CATALOGUE_PATH,
  IMAGE_SIZES_PATH,
  PUBLISH_PATH,
  TIERS_PATH,
} from './paths'

/** The screens that sit under the catalogue path and own their own selection. */
const SIBLING_PATHS = [PUBLISH_PATH, TIERS_PATH, IMAGE_SIZES_PATH]

export interface MenuCatalogueProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuCatalogue({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuCatalogueProps) {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={CATALOGUE_PATH}
        // Every sibling screen lives UNDER the catalogue path, so a bare prefix match would light
        // this one as well as the child the operator is actually on. Listed rather than reasoned
        // about: a new sibling that is not in SIBLING_PATHS lights two items at once, which is
        // exactly how this comment came to be here a second time.
        selected={
          pathname.startsWith(CATALOGUE_PATH) &&
          !SIBLING_PATHS.some((path) => pathname.startsWith(path))
        }
      >
        <ListItemIcon>
          <CollectionsOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'avatarStudio.sidebar.catalogue' })}
        />
      </MenuItem>
    </div>
  )
}
